import Session from '../auth/Session';

const BASE = 'api/Quote';

function authHeaders() {
    const token = Session.getToken();
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

// Fetches paginated quote list for the CSR dashboard.
export async function getAllQuotes(search = '', page = 1, pageSize = 10) {
    const params = new URLSearchParams({
        search,
        page: page.toString(),
        pageSize: pageSize.toString(),
    });

    const response = await fetch(`${BASE}/GetAllQuotes?${params}`, {
        headers: authHeaders(),
    });

    if (!response.ok) throw new Error(`GetAllQuotes failed: ${response.status}`);
    return response.json();
}

// Fetches full quote detail for read-only CSR view.
export async function getQuoteById(id) {
    const response = await fetch(`${BASE}/GetById/${id}`, {
        headers: authHeaders(),
    });

    if (!response.ok) throw new Error(`GetById failed: ${response.status}`);
    return response.json();
}